import Component from '../Component';

const { MediaPlaceholder } = wp.blockEditor;

export default class Image extends Component {
  static attributes(name) {
    return {
      type: 'array',
      source: 'query',
      selector: '[bb="' + name + '"]',
      query: {
        id: {
          type: 'string',
          source: 'attribute',
          attribute: 'bb-id',
        },
        url: {
          type: 'string',
          source: 'attribute',
          attribute: 'src',
        },
        alt: {
          type: 'string',
          source: 'attribute',
          attribute: 'alt',
        },
        title: {
          type: 'string',
          source: 'attribute',
          attribute: 'title',
        },
      },
    };
  }

  render() {
    if (this.isView()) {
      return this.image();
    }

    let attr = this.attr();

    if (!this.state.editImage && attr) {
      return this.image();
    }

    return (
      <MediaPlaceholder
        mediaPreview={this.image()}
        onSelect={val => {
          this.setAttr(val);
          this.closeMediaPlaceholder();
        }}
        onCancel={attr ? this.closeMediaPlaceholder.bind(this) : null}
        allowedTypes={['image']}
        multiple={false}
      />
    );
  }

  image() {
    let attr = this.attr();

    if (!attr) {
      return null;
    }

    if (Array.isArray(attr) && attr.length > 0) {
      attr = attr[0];
    }

    return (
      <img
        bb={this.name}
        bb-id={attr.id}
        className={this.props.className || null}
        src={attr.url}
        alt={attr.alt}
        title={attr.title}
        onDoubleClick={
          this.isView() ? null : this.openMediaPlaceholder.bind(this)
        }
      />
    );
  }

  openMediaPlaceholder() {
    this.setState(() => ({ editImage: true }));
  }

  closeMediaPlaceholder() {
    this.setState(() => ({ editImage: false }));
  }
}
